import { HTMLChakraProps, chakra } from '@chakra-ui/react'

export const Logo = (props: HTMLChakraProps<'svg'>) => {
  return (
    <chakra.svg
      height="24px"
      viewBox="0 0 2113 464"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1995.15 464.004C1968.28 464.004 1945.14 458.263 1925.72 446.781C1906.43 435.181 1891.52 418.905 1880.98 397.953C1870.56 376.883 1865.36 352.203 1865.36 323.912C1865.36 295.976 1870.56 271.355 1880.98 250.048C1891.52 228.742 1906.19 212.11 1925.01 200.155C1943.95 188.199 1966.09 182.222 1991.42 182.222C2006.81 182.222 2021.72 184.767 2036.17 189.857C2050.61 194.947 2063.57 202.937 2075.05 213.827C2086.53 224.717 2095.59 238.862 2102.22 256.263C2108.85 273.545 2112.16 294.556 2112.16 319.296V338.117H1895.36V298.344H2060.14C2060.14 284.376 2057.29 272.006 2051.61 261.234C2045.93 250.344 2037.94 241.762 2027.64 235.489C2017.46 229.215 2005.51 226.078 1991.78 226.078C1976.86 226.078 1963.84 229.748 1952.71 237.087C1941.7 244.307 1933.18 253.777 1927.15 265.496C1921.23 277.096 1918.27 289.703 1918.27 303.315V334.388C1918.27 352.617 1921.46 368.124 1927.86 380.908C1934.37 393.692 1943.42 403.457 1955.02 410.205C1966.62 416.833 1980.18 420.148 1995.68 420.148C2005.74 420.148 2014.92 418.727 2023.2 415.886C2031.49 412.927 2038.65 408.547 2044.69 402.747C2050.72 396.947 2055.34 389.786 2058.54 381.263L2108.79 390.318C2104.76 405.115 2097.54 418.076 2087.12 429.203C2076.83 440.212 2063.86 448.794 2048.24 454.949C2032.73 460.986 2015.04 464.004 1995.15 464.004Z"
        fill="currentColor"
      />
      <path
        d="M1628.86 458.5V422.101L1776.59 234.424V231.938H1633.65V185.773H1842.81V224.48L1700.77 409.85V412.335H1847.79V458.5H1628.86Z"
        fill="currentColor"
      />
      <path
        d="M1535.03 458.5V185.773H1588.12V458.5H1535.03ZM1561.84 143.692C1552.61 143.692 1544.68 140.614 1538.05 134.459C1531.54 128.185 1528.28 120.728 1528.28 112.087C1528.28 103.327 1531.54 95.87 1538.05 89.7147C1544.68 83.441 1552.61 80.3042 1561.84 80.3042C1571.07 80.3042 1578.94 83.441 1585.45 89.7147C1592.08 95.87 1595.4 103.327 1595.4 112.087C1595.4 120.728 1592.08 128.185 1585.45 134.459C1578.94 140.614 1571.07 143.692 1561.84 143.692Z"
        fill="currentColor"
      />
      <path
        d="M1510.14 185.773L1411.24 458.5H1354.42L1255.34 185.773H1312.34L1381.41 395.645H1384.25L1453.14 185.773H1510.14Z"
        fill="currentColor"
      />
      <path
        d="M1133.72 464.004C1106.85 464.004 1083.71 458.263 1064.3 446.781C1045 435.181 1030.09 418.905 1019.55 397.953C1009.14 376.883 1003.93 352.203 1003.93 323.912C1003.93 295.976 1009.14 271.355 1019.55 250.048C1030.09 228.742 1044.77 212.11 1063.59 200.155C1082.53 188.199 1104.66 182.222 1130 182.222C1145.38 182.222 1160.3 184.767 1174.74 189.857C1189.18 194.947 1202.14 202.937 1213.62 213.827C1225.11 224.717 1234.16 238.862 1240.79 256.263C1247.42 273.545 1250.73 294.556 1250.73 319.296V338.117H1033.94V298.344H1198.71C1198.71 284.376 1195.87 272.006 1190.19 261.234C1184.5 250.344 1176.51 241.762 1166.22 235.489C1156.04 229.215 1144.08 226.078 1130.35 226.078C1115.44 226.078 1102.41 229.748 1091.29 237.087C1080.28 244.307 1071.76 253.777 1065.72 265.496C1059.8 277.096 1056.84 289.703 1056.84 303.315V334.388C1056.84 352.617 1060.04 368.124 1066.43 380.908C1072.94 393.692 1082 403.457 1093.6 410.205C1105.2 416.833 1118.75 420.148 1134.26 420.148C1144.32 420.148 1153.49 418.727 1161.78 415.886C1170.06 412.927 1177.23 408.547 1183.26 402.747C1189.3 396.947 1193.92 389.786 1197.11 381.263L1247.36 390.318C1243.34 405.115 1236.11 418.076 1225.7 429.203C1215.4 440.212 1202.44 448.794 1186.81 454.949C1171.31 460.986 1153.61 464.004 1133.72 464.004Z"
        fill="currentColor"
      />
      <path
        d="M859.053 458.5V185.773H910.367V229.097H913.208C918.179 214.419 926.939 202.877 939.486 194.473C952.152 185.95 966.475 181.689 982.455 181.689C985.769 181.689 989.675 181.807 994.173 182.044C998.79 182.281 1002.4 182.577 1005 182.932V233.713C1002.87 233.121 999.086 232.47 993.641 231.76C988.196 230.931 982.751 230.517 977.306 230.517C964.758 230.517 953.572 233.18 943.747 238.507C934.041 243.715 926.347 250.995 920.665 260.347C914.983 269.58 912.142 280.115 912.142 291.952V458.5H859.053Z"
        fill="currentColor"
      />
      <path
        d="M573.017 142.094V94.8638H854.444V142.094H740.985V458.5H686.298V142.094H573.017Z"
        fill="currentColor"
      />
      <path
        d="M0 175.728V0L155.694 91.7845L312.312 0L462 85.7885L155.694 265.206V458H0V351.456L155.694 265.206L0 175.728Z"
        fill="currentColor"
      />
    </chakra.svg>
  )
}

export const LogoIcon = (props: HTMLChakraProps<'svg'>) => {
  return (
    <chakra.svg
      width="1em"
      height="1em"
      viewBox="0 0 500 497"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 190.5V0L168.5 99.5L338 0L500 93L168.5 287.5V496.5H0V381L168.5 287.5L0 190.5Z"
        fill="currentColor"
      />
    </chakra.svg>
  )
}
